import type { ModuloWeb } from '../../nucleo/modulos-web';
import { CentrosCusto } from './CentrosCusto';
import { Categorias } from './Categorias';
import { Conciliacao } from './Conciliacao';
import { Contas } from './Contas';
import { EntradasSaidas } from './EntradasSaidas';
import { FluxoCaixa } from './FluxoCaixa';
import { Indices } from './Indices';
import { i18n } from './i18n';
import { buscaFinanceiro } from './busca-global';

const modulo: ModuloWeb = {
  slug: 'financeiro',
  menu: 'financeiro',
  ordem: 10,
  // Fase 2 (W31, decisão 6): o menu Financeiro é uma linha só (A receber, A pagar, Cobranças, Recorrências, Notas de crédito,
  // Movimentações, Conciliação, Fluxo de caixa, Índices); `posicao` ordena as abas dos dois módulos juntas.
  abas: [
    { chave: 'entradas-saidas', permissao: 'financeiro.ver', componente: EntradasSaidas, posicao: 60 },
    // Fase 2 (W6, L1): cadastros do Financeiro moram em Cadastros; aqui ficam as telas de execução. W31: no grupo Financeiro.
    { chave: 'contas', permissao: 'financeiro.ver', componente: Contas, menu: 'cadastros', grupo: 'financeiro', posicao: 65 },
    { chave: 'categorias', permissao: 'financeiro.ver', componente: Categorias, menu: 'cadastros', grupo: 'financeiro', posicao: 90 },
    { chave: 'centros-custo', permissao: 'financeiro.ver', componente: CentrosCusto, menu: 'cadastros', grupo: 'financeiro', posicao: 60 },
    { chave: 'conciliacao', avancada: true, permissao: 'financeiro.ver', componente: Conciliacao, posicao: 70 },
    { chave: 'fluxo-caixa', permissao: 'financeiro.ver', componente: FluxoCaixa, posicao: 80 },
    // Fase 2 (W31, item 2): os índices do Banco Central saíram da barra superior e viraram página. A faixa aparecia para
    // qualquer sessão; aqui, para quem vê o menu Financeiro (pelo Financeiro ou pelo Contas).
    { chave: 'indices', avancada: true, permissao: ['financeiro.ver', 'contas.ver'], componente: Indices, posicao: 90 },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaFinanceiro,
};

export default modulo;
